import React, { useEffect, useState } from 'react';
import NavBar from '../common/NavBar';
import Footer from '../common/Footer';
import GuestMenu from "./GuestMenu";
import { useTranslation } from 'react-i18next';
import GuestReviewModal from "./GuestsModals/GuestReviewModal";

const GuestReviews = () => {
  const { t } = useTranslation();
  const [reviews, setReviews] = useState([]);
  const [apartments, setApartments] = useState({});      // id â†’ name
  const [bookingDates, setBookingDates] = useState({});  // booking_id â†’ { start, end }
  const [userGroup, setUserGroup] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingReview, setEditingReview] = useState(null);
  const [reviewValue, setReviewValue] = useState(0);
  const [reviewComment, setReviewComment] = useState("");
  const [updating, setUpdating] = useState(false);

  const getApiBaseUrl = () => process.env.REACT_APP_API_URL || "http://localhost:8000";
  const authHeader = () => ({ Authorization: `Token ${localStorage.getItem("token")}` });

  // â”€â”€ Bootstrap user from localStorage â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const storedUserId = localStorage.getItem("user_id");
    const rawGroups = localStorage.getItem("groups");
    let storedGroups = [];
    if (rawGroups) {
      try {
        const parsed = JSON.parse(rawGroups);
        storedGroups = Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        storedGroups = [rawGroups];
      }
    }
    if (storedUserId) setUserId(parseInt(storedUserId, 10));
    if (storedGroups.includes("Owners")) setUserGroup("Owners");
    else if (storedGroups.includes("Guests")) setUserGroup("Guests");
  }, []);

  // â”€â”€ Load reviews whenever userId is ready â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    if (userId && userGroup === "Guests") {
      loadReviews(userId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, userGroup]);

  // â”€â”€ Main data loading â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const loadReviews = async (guestId) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");

      // 1. Fetch past bookings for this guest
      const bookingsRes = await fetch(
        `${getApiBaseUrl()}/api/bookings/?guest_id=${guestId}`,
        { headers: { Authorization: `Token ${token}` } }
      );
      const allBookings = await bookingsRes.json();

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const pastBookings = allBookings.filter((b) => new Date(b.end_date) < today);

      // Collect booking date info for display
      const datesMap = {};
      pastBookings.forEach((b) => { datesMap[b.id] = { start: b.start_date, end: b.end_date }; });
      setBookingDates(datesMap);

      // 2. Fetch apartments
      const aptsRes = await fetch(
        `${getApiBaseUrl()}/api/properties/apartments/`,
        { headers: { Authorization: `Token ${token}` } }
      );
      const aptsData = await aptsRes.json();
      const aptsMap = {};
      aptsData.forEach((a) => { aptsMap[a.id] = a.apartment_name; });
      setApartments(aptsMap);

      // 3. Fetch existing reviews for this guest
      const reviewsRes = await fetch(
        `${getApiBaseUrl()}/api/reviews/?guest_id=${guestId}`,
        { headers: { Authorization: `Token ${token}` } }
      );
      let existingReviews = await reviewsRes.json();
      if (!Array.isArray(existingReviews)) existingReviews = existingReviews.results || [];

      const reviewedBookingIds = new Set(existingReviews.map((r) => r.booking));

      // 4. Create pending reviews for past bookings that don't have one yet
      const createPromises = pastBookings
        .filter((b) => !reviewedBookingIds.has(b.id))
        .map((b) =>
          fetch(`${getApiBaseUrl()}/api/reviews/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
            body: JSON.stringify({
              booking: b.id,
              apartment: b.apartment,
              status: "pending",
              value: 0,
              comment: "",
            }),
          })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        );

      const newReviews = (await Promise.all(createPromises)).filter(Boolean);

      // 5. Combine and show all reviews for past bookings only
      const allReviews = [...existingReviews, ...newReviews];
      const pastBookingIds = new Set(pastBookings.map((b) => b.id));
      setReviews(allReviews.filter((r) => pastBookingIds.has(r.booking)));
    } catch (error) {
      console.error("Error loading reviews:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // â”€â”€ Modal helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const openUpdateModal = (review) => {
    setEditingReview(review);
    setReviewValue(review.value || 0);
    setReviewComment(review.comment || "");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingReview(null);
    setReviewValue(0);
    setReviewComment("");
  };

  const handleUpdateReview = async () => {
    if (!editingReview) return;
    setUpdating(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/reviews/${editingReview.id}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...authHeader(),
          },
          body: JSON.stringify({
            booking: editingReview.booking,
            apartment: editingReview.apartment,
            guest: editingReview.guest,
            value: reviewValue,
            comment: reviewComment,
            status: "done",
          }),
        }
      );
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Failed to update review");
      }
      // Refresh list
      await loadReviews(userId);
      closeModal();
    } catch (error) {
      alert(`${t("error_updating_review")}: ${error.message}`);
    } finally {
      setUpdating(false);
    }
  };

  // â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <NavBar />
        <div className="flex-1 flex items-center justify-center">
          <p>{t("loading")}</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      {userGroup === "Guests" && <GuestMenu />}

      <div className="flex flex-col items-center mt-16 px-4">
        <h1 className="text-3xl font-bold mb-8">{t("reviews")}</h1>

        {reviews.length === 0 ? (
          <p className="text-gray-500">{t("no_reviews_found")}</p>
        ) : (
          <div className="w-full max-w-5xl overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-sm">
              <thead>
                <tr className="bg-gray-100 text-center text-sm font-semibold text-gray-700">
                  <th className="py-3 px-4 border-b">{t("booking_id")}</th>
                  <th className="py-3 px-4 border-b">{t("apartment")}</th>
                  <th className="py-3 px-4 border-b">{t("start_date")}</th>
                  <th className="py-3 px-4 border-b">{t("end_date")}</th>
                  <th className="py-3 px-4 border-b">{t("status")}</th>
                  <th className="py-3 px-4 border-b">{t("rating")}</th>
                  <th className="py-3 px-4 border-b">{t("comment")}</th>
                  <th className="py-3 px-4 border-b">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {reviews.map((review) => {
                  const dates = bookingDates[review.booking] || {};
                  return (
                    <tr key={review.id} className="hover:bg-gray-50 text-center text-sm">
                      <td className="py-3 px-4 border-b">{review.booking}</td>
                      <td className="py-3 px-4 border-b">
                        {apartments[review.apartment] || `Apartment ${review.apartment}`}
                      </td>
                      <td className="py-3 px-4 border-b">{dates.start || "\u2014"}</td>
                      <td className="py-3 px-4 border-b">{dates.end || "\u2014"}</td>
                      <td className="py-3 px-4 border-b capitalize">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          review.status === "done"
                            ? "bg-green-100 text-green-700"
                            : "bg-yellow-100 text-yellow-700"
                        }`}>
                          {review.status}
                        </span>
                      </td>
                      <td className="py-3 px-4 border-b">
                        {review.value ? "\u2605".repeat(review.value) + "\u2606".repeat(5 - review.value) : "\u2014"}
                      </td>
                      <td className="py-3 px-4 border-b max-w-xs truncate">
                        {review.comment || "\u2014"}
                      </td>
                      <td className="py-3 px-4 border-b">
                        <button
                          onClick={() => openUpdateModal(review)}
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition text-xs"
                        >
                          {review.status === "pending" ? t("add_review") : t("update")}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Footer />

      <GuestReviewModal
        show={showModal}
        reviewValue={reviewValue}
        setReviewValue={setReviewValue}
        reviewComment={reviewComment}
        setReviewComment={setReviewComment}
        onClose={closeModal}
        onUpdate={handleUpdateReview}
        updating={updating}
      />
    </div>
  );
};

export default GuestReviews;

